import { useSelector } from 'react-redux';
import { useQueries } from '@tanstack/react-query';
import { widgetsNoDatasetOutput } from '../WidgetLibraryGen2';
import {
    dataset_get_data_path,
} from '~/routes';
import { fetchJson } from '../../../helpers';

export const datasetsConfigured = (datasets) => datasets.some((d) => d.dataset_id != "");

export const useDataset = ({
    datasetDataParams = {},
    widgetId
}) => {
    const widget_type = useSelector(state => state.dashboard.widgets[widgetId].widget_type);
    const datasets = useSelector(state => state.dashboard.widgets[widgetId].settings?.datasets) || [];
    const wholeDatasets = useSelector(state => state.dashboard.widgets[widgetId].settings?.wholeDatasets) || [];
    const currentDatasets = widgetsNoDatasetOutput.includes(widget_type) ? wholeDatasets : datasets;
    const dashboardType = useSelector(state => state.dashboard.dashboardType);
    const datasetIds = [...new Set(currentDatasets.flatMap((d) => [d.dataset_id, d.target_dataset_id]).filter((id) => id))];

    const datasetsData = useQueries({
        queries: datasetIds.map(id => ({
            queryKey: ['get_dataset', id],
            queryFn: () => fetchJson(dataset_get_data_path({ ...datasetDataParams, uuid: id.split("_")[0], output: id.split("_")[1] })),
            enabled: dashboardType !== 'public'
        })),
        combine: (results) => {
            let fetchedData = {};
            let failedData = {};
            results.forEach((result, index) => {
                const id = datasetIds[index];

                if (result.isSuccess) {
                    fetchedData[id] = result.data;
                }

                if (result.isError) {
                    failedData[id] = { loadError: true };
                }
            });
            return {loading: results.some(r => r.isLoading), data: {...fetchedData, ...failedData}}
        },
    })


    const getNumberUnit = (datasetIndex) => (datasets[datasetIndex] || {}).number_unit;
    const getNumberPrecision = (datasetIndex) => (datasets[datasetIndex] || {}).number_precision;
    const getCommonUnit = () => {
        const datasetNumberUnits = [...new Set(datasets.map((d) => d.number_unit))];
        return datasetNumberUnits.length == 1 ? datasetNumberUnits[0] : null;
    }
    const getCommonPrecision = () => {
        const precision = datasets.map((d) => d.number_precision).sort()[0];
        return precision === undefined ? 2 : precision;
    }

    const getCommonNumberUnit = () => {
        const datasetNumberUnits = [...new Set(datasets.map((d) => d.number_unit))];
        return datasetNumberUnits.length == 1 ? datasetNumberUnits[0] : null;
    }

    return {
        getNumberUnit,
        getNumberPrecision,
        getCommonUnit,
        getCommonPrecision,
        getCommonNumberUnit,
        data: datasetsData.data,
        loading: datasetsData.loading
    }
}
